export default {
      id: "screenshot-usage",
      viewBox: "0 0 21 17",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#screenshot",
      toString: function () {
        return this.url;
      }
    }